import "./index.css";
import "@mantine/tiptap/styles.css";

import { ErrorBoundary, Provider } from "@rollbar/react";

import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import rollbar from "utils/rollbar";

// import "./applyDomainClass.js";

function ErrorBoundaryLayout({ children }: any) {
  try {
    return children;
  } catch (err: any) {
    console.error("Render error:", err);
    return (
      <div style={{ padding: 20, color: "red" }}>
        App crashed: {err.message}
      </div>
    );
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundaryLayout>
      <Provider instance={rollbar}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>
    </ErrorBoundaryLayout>
  </React.StrictMode>
);
